// 1000 milliseconds * 60 seconds * 60 minutes * 24 hours = 1 Day
export const ONE_DAY_IN_MS: number = 1000 * 60 * 60 * 24;

export const AQUA_TEST_FACILITY_ID = '100001';
